import React, { useState } from 'react';
import { useTheme } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { sortBy } from 'lodash/fp';
import { useUser } from '../../../../utils/hooks/auth';
import {
    CreateWarehouseMutationVariables,
    refetchWarehousesQuery,
    useCreateWarehouseMutation,
    useGetInitInfoQuery,
} from '../../../../generated/graphql';
import { routePaths } from '../../../../routePaths';
import { FullScreenDialog } from '../../../../ui-kit';
import WarehouseForm, { WarehouseFormValues } from './WarehouseForm';

const CreateWarehouseForm = () => {
    const [isDialogOpened, setIsDialogOpened] = useState(true);
    const history = useHistory();
    const theme = useTheme();
    const { user: { currentVenueId } } = useUser();
    const { data } = useGetInitInfoQuery({ fetchPolicy: 'cache-only' });
    const venues = data ? data.venues : [];
    const sortedVenues = sortBy(['name', 'asc'], venues);

    const onClose = () => {
        setIsDialogOpened(false);
        setTimeout(() => history.push(routePaths.warehouses), theme.transitions.duration.leavingScreen);
    };

    const [runMutation] = useCreateWarehouseMutation({ refetchQueries: [refetchWarehousesQuery()] });
    const onSubmit = async ({ name, venueIds }: WarehouseFormValues) => {
        const variables: CreateWarehouseMutationVariables = {
            name,
            venueIds,
        };

        await runMutation({ variables });
        onClose();
    };

    const { t } = useTranslation();


    return (
        <FullScreenDialog isOpened={isDialogOpened}>
            <WarehouseForm
                buttonText={t('Create')}
                dialogName={t('New warehouse')}
                onClose={onClose}
                currentVenueId={currentVenueId}
                onSubmit={onSubmit}
                venues={sortedVenues}
            />
        </FullScreenDialog>
    );
};

export default CreateWarehouseForm;
